define('app-ModalComponent/settings',[],function () {
    return {
        container: '.componentModalLink'
    };
});
